import { FC, useEffect, useState } from 'react';
import { ChangeDeliveryDateModalViewType } from '../../../types/view/ChangeDeliveryDateModalViewType';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../assets/css/datepickerCustom.css';
import changeDeliveryDateModalClass from '../../../assets/scss/ChangeDeliveryDateModal/ChangeDeliveryDateModal.module.scss';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { useMasterContext } from '../../../context';

export const ChangeDeliveryDate: FC<{
  changeDeliveryDateModal: ChangeDeliveryDateModalViewType;
  changeDeliveryDateFunc: (date: Date) => void;
  clickPullDownEventFunc: () => void;
}> = ({ changeDeliveryDateModal, changeDeliveryDateFunc, clickPullDownEventFunc }) => {
  const { excludeDates } = useMasterContext();

  const [formattedExcludeDates, setFormattedExcludeDates] = useState<Date[] | undefined>(undefined);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  useEffect(() => {
    if (excludeDates.length !== 0) {
      const excludeDatesFormat = excludeDates.map((item) => new Date(item));
      setFormattedExcludeDates(excludeDatesFormat);
    } else {
      setFormattedExcludeDates(undefined);
    }
  }, [excludeDates]);

  const minDate = dayjs().add(5, 'day').toDate();
  const maxDate = dayjs().add(60, 'day').toDate();

  return (
    <div className={changeDeliveryDateModalClass.field}>
      <span className={changeDeliveryDateModalClass.fieldTitle}>お届け日</span>
      <div
        className={changeDeliveryDateModalClass.selectDate}
        style={{ borderRadius: isDatePickerOpen ? '4px 4px 0 0' : '4px' }}
        onClick={() => {
          setIsDatePickerOpen((prev) => !prev);
          clickPullDownEventFunc();
        }}
      >
        <span className={changeDeliveryDateModalClass.selectText}>
          {dayjs(changeDeliveryDateModal.nextDeliveryDate).format('YYYY/M/D（ddd）')}
        </span>
        <span className={changeDeliveryDateModalClass.pipe} />
        <span className={changeDeliveryDateModalClass.lowerTriangle} />
      </div>

      {isDatePickerOpen && (
        <div className={changeDeliveryDateModalClass.datepickerWrapper}>
          <DatePicker
            locale="ja"
            dateFormat="YYYY/M/D"
            minDate={minDate}
            maxDate={maxDate}
            selected={changeDeliveryDateModal.nextDeliveryDate}
            disabledKeyboardNavigation
            filterDate={(date) => !changeDeliveryDateModal.disableWeek[date.getDay()]}
            excludeDates={formattedExcludeDates}
            onChange={(date) => {
              if (!date) return;
              setIsDatePickerOpen(false);
              changeDeliveryDateFunc(date);
            }}
            onChangeRaw={(e) => e.preventDefault()}
            inline={true}
            calendarContainer={({ children }) => (
              <div style={{ display: 'inline-block', margin: '24px auto' }}>{children}</div>
            )}
            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
              <div className={changeDeliveryDateModalClass.datepickerHeader}>
                <button
                  className={changeDeliveryDateModalClass.datepickerHeaderPrev}
                  onClick={decreaseMonth}
                  disabled={dayjs(date).subtract(1, 'month').endOf('month').isBefore(minDate)}
                />
                <div style={{ fontSize: '13px', lineHeight: '14px' }}>
                  <span className={changeDeliveryDateModalClass.datepickerTitle}>
                    {date.getFullYear()}
                  </span>
                  年
                  <span
                    className={changeDeliveryDateModalClass.datepickerTitle}
                    style={{ marginLeft: '10px' }}
                  >
                    {date.getMonth() + 1}
                  </span>
                  月
                </div>
                <button
                  className={changeDeliveryDateModalClass.datepickerHeaderNext}
                  onClick={increaseMonth}
                  disabled={dayjs(date).endOf('month').isAfter(maxDate)}
                />
              </div>
            )}
          />
        </div>
      )}
    </div>
  );
};
